// if you need to add custom js put it in here
$(window).load(function () {
    $('.HButton').bootstrapSwitch();
});
